export default "__VITE_ASSET__DWhEfyK6__"